import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Flat%20lay%20editorial%20photography%20of%20diverse%20fashion%20accessories%20and%20clothing%20items%20arranged%20artistically%20on%20a%20white%20marble%20surface%2C%20soft%20diffused%20natural%20morning%20light%2C%20warm%20beige%20and%20cream%20tones%2C%20minimalist%20Scandinavian%20aesthetic%2C%20high-end%20catalog%20look%2C%20clean%20composition%20with%20negative%20space%2C%20subtle%20shadows%2C%20lifestyle%20editorial%20quality&width=1600&height=900&seq=hero-hipobuy-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet - Curated fashion product discovery"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold tracking-wide uppercase">
            Updated 2026
          </span>
          <span className="px-3 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium backdrop-blur-sm">
            Independent Research
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-5">
          The Ultimate Hipobuy Spreadsheet Resource Hub
        </h1>

        <p className="text-sm md:text-base text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of curated product finds, shopping guides, comparisons, and spreadsheet resources designed to help shoppers make smarter purchasing decisions across every category.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-line"></i>
            Buy It Now
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-background-50/15 text-background-50 border border-background-50/30 text-sm md:text-base font-semibold hover:bg-background-50/25 backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line"></i>
            Hipobuy Sheet
          </a>
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-background-50/10 text-background-50 border border-background-50/20 text-sm md:text-base font-medium hover:bg-background-50/20 backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            Read Full Guide
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 mt-10 text-background-50/75 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Updated Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Independent Reviews
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Comparison Tables
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Safety Resources
          </span>
        </div>
      </div>
    </section>
  );
}